import { render } from "./subjectSelected.vue?vue&type=template&id=62759fc9&scoped=true"
import script from "./subjectSelected.vue?vue&type=script&lang=js"
export * from "./subjectSelected.vue?vue&type=script&lang=js"

import "./subjectSelected.vue?vue&type=style&index=0&id=62759fc9&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62759fc9"]])

export default __exports__